<!-- 底部组件 -->
<template>
  <footer class="footer">
    <div class="top">
      <div class="navs">
        <router-link to="/" class="nav">{{ $t("nav.home") }}</router-link>
        <router-link to="/plan-trip" class="nav">{{
          $t("nav.planTrip")
        }}</router-link>
        <router-link to="/destination/region/sichuan" class="nav">{{
          $t("nav.destinations")
        }}</router-link>
        <router-link to="/guide/srdz" class="nav">{{
          $t("nav.travelThemes")
        }}</router-link>
        <router-link to="/#testimonials" class="nav">{{
          $t("nav.testimonials")
        }}</router-link>
        <router-link to="/about" class="nav">{{ $t("nav.about") }}</router-link>
        <router-link to="/contact" class="nav">{{
          $t("nav.contact")
        }}</router-link>
      </div>
    </div>
    <div class="center">
      <router-link to="/">
        <img :src="logo" alt="logo" class="logo" />
      </router-link>
      <div class="infoes">
        <div class="info">{{ $t("footer.companyName") }}</div>
        <div class="info">{{ $t("footer.phone") }}</div>
        <div class="info">{{ $t("footer.address") }}</div>
      </div>
    </div>
    <div class="bottom">
      <div class="info">{{ $t("footer.copyright") }}</div>
      <div class="info">
        <a target="_blank" href="https://beian.miit.gov.cn/">蜀123123123</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    logo() {
      return this.$i18n.locale === "zh-CN"
        ? require("@/assets/logo/logoZh.png")
        : require("@/assets/logo/logoEn.png");
    },
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang='scss' scoped>
.footer {
  width: 100%;
  background-color: rgb(15, 17, 29);

  .top {
    border-bottom: 1px solid #6c6e77;
  }

  .navs {
    width: 1200px;
    height: 120px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    color: #6c6e77;

    .nav {
      color: #6c6e77;
      text-decoration: none;

      &:hover {
        color: #fff;
        cursor: pointer;
      }
      & + .nav {
        margin-left: 100px;
      }
    }
  }

  .center {
    width: 1200px;
    margin: 0 auto;
    padding: 60px 0;

    .logo {
      width: 300px;
    }
    .infoes {
      color: #6c6e77;
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
    }
  }

  .bottom {
    padding: 10px 0;
    color: #6c6e77;
    font-size: 12px;
    display: flex;
    justify-content: center;
    border-top: 1px solid #6c6e77;

    .info {
      margin-bottom: 5px;

      & + .info {
        margin-left: 10px;
      }

      a {
        color: #6c6e77;
        text-decoration: none;

        &:hover {
          color: #fff;
        }
      }
    }
  }

  .content_item {
    margin: 10px 0;

    .version {
      font-size: 14px;
      margin-bottom: 25px;

      a {
        color: #999;
      }
    }
  }
  .other_item {
    margin: 8px 0;

    span {
      margin-left: 5px;
      padding-left: 5px;
    }
    a {
      color: #999;
    }
  }
}
</style>
